export default function initHowItWorksSteps() {
    const hiwModule = document.querySelector('[data-partnership-hiw]');
    if (!hiwModule) {
        return;
    }

    const defaultActiveStep = hiwModule.querySelector('[data-partnership-hiw-step="1"]');

    const steps = Array.from(hiwModule.querySelectorAll('[data-partnership-hiw-step]'));
    steps.forEach(step => {
        step.addEventListener('mouseenter', handleMouseEnter);
        step.addEventListener('mouseleave', handleMouseLeave);
    });

    function handleMouseEnter(e: Event) {
        const step = <Element>e.target;

        if (step === defaultActiveStep) {
            return;
        }

        if (step && defaultActiveStep) {
            step.setAttribute('data-partnership-hiw-active', 'true');
            defaultActiveStep.removeAttribute('data-partnership-hiw-active');
        }
    }

    function handleMouseLeave(e: Event) {
        const step = <Element>e.target;

        if (step === defaultActiveStep) {
            return;
        }

        if (step && defaultActiveStep) {
            step.removeAttribute('data-partnership-hiw-active');
            defaultActiveStep.setAttribute('data-partnership-hiw-active', 'true');
        }
    }
}
